import { formatDate } from '@helpers/miscelleanous';
import useClient from '@hooks/useClient';
import { Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';

const WebinarsList = ({ webinarsList, isCarousel = false }) => {
    const sortedWebinarsList =
        webinarsList?.length > 0
            ? webinarsList
                  ?.sort(function (a, b) {
                      return new Date(b.date) - new Date(a.date);
                  })
                  .slice(0, 3)
            : [];
    const { isClient } = useClient();
    const [currentPlayingId, setCurrentPlayingId] = useState(null);

    return sortedWebinarsList.map((webinar, index) => (
        <div
            key={webinar?.id}
            className={cn(
                'w-full flex flex-col h-[276px] rounded-3xl overflow-hidden shadow-md bg-basicWhite',
                isCarousel && 'min-w-[280px]',
                isCarousel && index === 0 && 'ml-4',
                !isCarousel &&
                    index === sortedWebinarsList.length - 1 && [
                        'md:col-span-2',
                        'md:col-start-1',
                        'md:mx-auto',
                        'md:max-w-[50%]',
                        'lg:col-span-1',
                        'lg:col-start-auto',
                        'lg:mx-0',
                        'lg:max-w-none',
                    ]
            )}
            id={webinar?.id}
        >
            <div className={`h-[180px] w-full`}>
                {isClient ? (
                    <ReactPlayer
                        height="100%"
                        width="100%"
                        url={webinar?.url}
                        stopOnUnmount
                        playing={currentPlayingId === webinar?.id}
                        controls
                        onPlay={() => setCurrentPlayingId(webinar?.id)}
                    />
                ) : (
                    <div className="h-full w-full bg-gray-100" />
                )}
            </div>

            <div className="flex flex-col flex-1 justify-between gap-2 px-4 py-3">
                <div>
                    <h2 className="h6-semibold text-gray-900 line-clamp-2">
                        {webinar?.title}
                    </h2>
                </div>

                <footer className="flex gap-2 items-center">
                    {webinar?.date ? (
                        <Text
                            content={`Recorded on ${formatDate(webinar.date)}`}
                            className="p5-medium text-primary-500"
                        />
                    ) : (
                        <span className="w-1/2" />
                    )}
                </footer>
            </div>
        </div>
    ));
};

export default WebinarsList;
